export class AuthService {
    constructor($http, $cookies, $location, $route, $rootScope, $window, toastr) {
        this.http = $http;
        this.cookies = $cookies;
        this.location = $location;
        this.route = $route;
        this.window = $window;
        this.rootScope = $rootScope;
        this.isLoggedIn = false;
        this.isAdmin = false;
        this.isModerator = false;
        this.isLoaded = false;
        this.toastr = toastr;
    }

    login(username, password, remember) {
      let params = {
        username: username,
        password: password,
        remember: remember
      };

      this.http.post('/api/login', params)
        .then((response) => { let result = response.data;
          this.isLoggedIn = true;
          this.window.location.href = '/homerd';
        })
        .catch((response) => { let err = response.data;
            if(err.message) {
                this.toastr.error(err.message);
            }
        });
    }

    logout() {
      this.http.post('/api/logout', '')
        .then((response) => {
          this.window.location.href = '/';
        })
        .catch((response) => {
          console.error(response.data);
          this.window.location.href = '/';
        });
    }

    isAuthenticated(callback) {
        if(/^\/(eventos|seo)/.test(this.location.path())) {
            this.isAdmin = false;
            this.isModerator = false;
            this.isLoggedIn = false;
            this.isLoaded = true;

            if (typeof callback === 'function') {
                callback(this.isLoggedIn)
            } else {
                return;
            }
        }

        this.http.post('/api/isauthenticated')
            .then((res) => {
                if (!res || !res.data || !res.data.success) {
                    this.isAdmin = false;
                    this.isModerator = false;
                    this.isLoggedIn = false;
                    if (!/^\/(landingA|landingB|landingC|landingD)?$/.test(this.location.path()) && !(/^\/(blogrd\/blog-detail)/.test(this.location.path()) || this.location.path() == '/blogrd' || this.location.path() == '/blogrd/index/op/ranking')) {
                        this.window.location.href = '/';
                        return;
                    }
                } else {
                    if (
                      (/^\/admin/i.test(this.location.path()))
                      && !res.data.isAdmin
                      && !res.data.isModerator) {
                        this.location.path('/homerd');
                        return;
                    }

                    if(/^\/admin\/(user-chart|payment-chart|campaign-template|campaign|permanent-contacts|banner-crud)$/i.test(this.location.path()) && res.data.isModerator === true) {
                         this.location.path('/homerd');
                        return;
                      }
                    this.isAdmin = res.data.isAdmin;
                    this.isModerator = res.data.isModerator;
                    this.isLoggedIn = true;

                    if (/^\/(\/|landingA|landingB|landingC|landingD)?$/.test(this.location.path())) {
                        this.window.location.href = '/homerd';
                        return;
                    }
                }

                if (typeof callback === 'function') {
                    callback(this.isLoggedIn)
                }

                this.isLoaded = true;
            }, (err) => {
                if (err) {
                    console.log(err);
                }

                this.isAdmin = false;
                this.isModerator = false;
                this.isLoggedIn = false;
                if (this.location.path() !== '/') {
                    this.window.location.href = '/';
                    return;
                }

                if (typeof callback === 'function') {
                    callback(this.isLoggedIn)
                }

                this.isLoaded = true;
            })
    }

    redirect() {
      let params = this.route.current.params;
      let url = params.url;

      params.url = '';
      params.url = url.replace(',', '/');

      if(!this.isLoggedIn) {
        this.http.get(`/api/redirect/${params.user}/${params.hash}`)
          .then((response) => { let data = response.data;
            this.cookies.put('token', data.token, {expires: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)});
            this.isAuthenticated();
            this.location.path(`${params.url}`);
        })
        .catch((response) => { let err = response.data;
          console.log(err);
          this.location.path(`/`);
        })
      } else {
        this.location.path(`${params.url}`);
      }
    }
}
